import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { IoNotificationsOutline } from "react-icons/io5";
import NotificationPopup from "./NotificationPopup";
import { useDispatch, useSelector } from "react-redux";
import { getUserById } from "../redux/actions/userActions";
import { fetchBildirimler } from "../redux/actions/bildirimActions";
import createSlug from "../utils/slug";

const Navbar = ({
  isOpen,
  isAuthenticated,
  setNotificationOpen,
  isNotificationOpen,
  setRatingIsOpen,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userId } = useSelector((state) => state.auth);
  const { user, loading, error } = useSelector((state) => state.user);
  const userName = user?.data?.name;
  const userNameSlug = userName ? createSlug(userName) : "";
  const { unreadCount } = useSelector((state) => state.bildirim);

  useEffect(() => {
    if (isNotificationOpen) {
      setNotificationOpen(false);
    }
  }, [location.pathname]);
  useEffect(() => {
    if (userId) {
      dispatch(getUserById(userId));
      dispatch(fetchBildirimler());
    }
  }, [userId, dispatch]);

  const handleNotificationClick = () => {
    if (window.innerWidth < 1180) {
      navigate("/bildirimler");
    } else {
      setNotificationOpen(!isNotificationOpen);
    }
  };

  return (
    <div
      className={` relative z-[100] ${
        !isOpen
          ? "hidden custom:flex justify-between gap-5 items-center"
          : "flex flex-col fixed top-[250px] right-[-40px] w-[220px] rounded-2xl bg-white shadow-lg z-40 p-8"
      }`}
    >
      <ul
        className={`justify-between gap-8 text-grayy  font-medium text-base leading-tight items-center ${
          !isOpen ? "hidden custom:flex" : "flex flex-col "
        }`}
      >
        <li>
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "text-darkerGreen" : "text-grayy hover:text-dark"
            }
          >
            Anasayfa
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/projeler"
            className={({ isActive }) =>
              isActive ? "text-darkerGreen" : "text-grayy hover:text-dark"
            }
          >
            Projeler
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/juniorlar"
            className={({ isActive }) =>
              isActive ? "text-darkerGreen" : "text-grayy hover:text-dark"
            }
          >
            Juniorlar
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/seniorlar"
            className={({ isActive }) =>
              isActive ? "text-darkerGreen" : "text-grayy hover:text-dark"
            }
          >
            Seniorlar
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/sikca-sorulan-sorular"
            className={({ isActive }) =>
              isActive ? "text-darkerGreen" : "text-grayy hover:text-dark"
            }
          >
            SSS
          </NavLink>
        </li>
        {isAuthenticated ? (
          <Link
            to={`/hesabim/${userNameSlug}`}
            className="btn-white flex gap-2 items-center w-[170px] whitespace-nowrap text-center h-[50px] justify-center"
          >
            {loading ? (
              <span>Yükleniyor...</span>
            ) : error ? (
              <span>Hata</span>
            ) : (
              <span className="truncate max-w-[120px]">
                {user?.data?.name || "Kullanıcı"}
              </span>
            )}
            <span>
              <img src="/person-circle.svg" alt="" className="w-6" />
            </span>
          </Link>
        ) : (
          <Link to="/giris_yap" className="btn-dark w-[120px] text-center">
            Giriş Yap
          </Link>
        )}
        {isAuthenticated ? (
          <div className="relative z-50">
            <button
              className="btn-white text-[26px] relative h-[50px]"
              onClick={handleNotificationClick}
            >
              <IoNotificationsOutline />
              {unreadCount > 0 && (
                <span className="text-white bg-dark text-[10px] p-1 absolute top-2 right-4 w-4 h-4 rounded-full flex items-center justify-center">
                  {unreadCount}
                </span>
              )}
            </button>
            {isNotificationOpen && (
              <div
                className="absolute top-[56px] right-[110px] mt-2 w-72 hidden custom:block
              "
              >
                <NotificationPopup
                  setNotificationOpen={setNotificationOpen}
                  isNotificationOpen={isNotificationOpen}
                  setRatingIsOpen={setRatingIsOpen}
                />
              </div>
            )}
          </div>
        ) : (
          <Link to="/kayit_ol" className="btn-green w-[120px] text-center">
            Kayıt Ol
          </Link>
        )}
      </ul>
    </div>
  );
};

export default Navbar;
